import { jsx as i } from "react/jsx-runtime";
import * as s from "@radix-ui/react-tooltip";
const a = (o) => {
  const { children: r, asChild: e, ...t } = o;
  return /* @__PURE__ */ i(s.Trigger, { asChild: !0, ...t, children: e ? r : /* @__PURE__ */ i("span", { children: r }) });
};
a.displayName = "Tooltip.Trigger";
export {
  a as Trigger
};
